import React, {useEffect, useState} from 'react';

import OnMapInfoPanel from "./OnMapInfoPanel";
import ShapeStyling from "../../shapes/ShapeStyling";
import ShapeToolbar from "../../shapes/ShapeToolbar";
import ShapePopup from "../../shapes/ShapePopup";
import ShapeNotesDisplay from "../../shapes/ShapeNotesDisplay";
import ShapeInfoPanelBufferRadius from "./ShapeInfoPanelBufferRadius";
import MarksToolbar from "../../marks/MarksToolbar";
import MarksInfoPanelBufferRadius from "./MarksInfoPanelBufferRadius";


export default function MarksInfoPanel({id, data, title, properties = {}, panelMinimize = false, bufferRadiusChanged, setCustomColor, selfDelete, onTitleChange, onNotesChange, onPanelMinimizeChange, onInitRefresh, onLayerToTop, onLayerToBottom, onToggleVisible, onTogglePopupTitle, onConvertShape, onSaveToFiles, canEdit = false}) {

    let measurementUnits = 'km';
    let currentUser = localStorage.getItem('user');
    if (currentUser && currentUser.settings && currentUser.settings.units && currentUser.settings.units === 'imperial') {
        measurementUnits = 'mi';
    }

    const [editMode, setEditMode] = React.useState(false);
    const [notesEditMode, setNotesEditMode] = React.useState(false);
    const [panelMinimized, setPanelMinimized] = React.useState(panelMinimize === true);

    let baseNotes = data.geoJSON && data.geoJSON.properties && data.geoJSON.properties.notes ? data.geoJSON.properties.notes : null;
    const [notes, setNotes] = useState(baseNotes);

    const [tempTitle, setTempTitle] = React.useState(title ? title : '');


    const updateTitle = (e) => {
        setTempTitle(e.target.value);
    }


    const save = () => {
        onTitleChange(tempTitle);
        setEditMode(false);
    }


    const updateNotes = (newNotes) => {
        setNotes(newNotes);
    }


    const saveNotes = () => {
        onNotesChange(notes);
        setNotesEditMode(false);
    }


    useEffect(() => {
        let baseNotes = data.geoJSON && data.geoJSON.properties && data.geoJSON.properties.notes ? data.geoJSON.properties.notes : null;
        setNotes(baseNotes);
    }, [data.geoJSON]);


    useEffect(() => {
        setTempTitle(title);
    }, [title]);


    const onMinimizePanel = (e) => {
        e.preventDefault();

        setEditMode(false);
        setPanelMinimized(!panelMinimized);
        onPanelMinimizeChange(!panelMinimized);
    }


    const formatNumber = (num) => {
        return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }


    if (!data.active) {return null;}
    return panelMinimized ? (
        <div className="btn-group-vertical">
            <button onClick={onMinimizePanel} onMouseOver={onMinimizePanel} type="button" className="btn btn-onmap panel-style-warning" aria-haspopup="true" aria-expanded="false">
                <i className={'ti ti-arrows-diagonal fs-4'}></i>
            </button>
        </div>
    ) : (<div className="d-flex flex-row align-items-start gap-2 shape-info-panel-container">
        <OnMapInfoPanel className={'style-warning map-info-panel' + (notesEditMode ? '' : ' short-form')}>
            {editMode ? (
                <div className="position-relative d-inline-block py-2 pe-5 w-50">
                    <input type="text" className="form-control map-info-control d-inline-block" value={tempTitle} onChange={updateTitle} onKeyDown={(e) => {
                        // check if enter key is pressed
                        if (e.keyCode === 13) {
                            save();
                        }
                    }} />
                    <button className="icon-button d-flex" onClick={save}><i className={'ti ti-device-floppy fs-4'}></i></button>
                </div>
            ) : (<div className="position-relative d-flex justify-content-between">
                <div className="position-relative d-inline-block pe-5">
                    <h3 className="h5 py-2 m-0 d-inline-block">Reference: {tempTitle}</h3>
                    <button className={'icon-button'+(!canEdit ? ' d-none' : '')} onClick={() => {
                        setEditMode(true)
                    }}><i className="ti ti-pencil fs-4"></i></button>
                </div>
            </div>)}

            {properties && Object.keys(properties).length > 0 ? (<>
            <div className="text-dark fw-medium">Estimated Counts:</div>
            <div className="">
                Households: {formatNumber(properties.houses_core || 0)} <br/>
                Businesses: {formatNumber(properties.business_core || 0)} <br/>
                Not Yet Built: {formatNumber((properties.business_nyb || 0) + (properties.houses_nyb || 0))} <br/>
                Total: {formatNumber((properties.houses_core || 0) + (properties.business_core || 0) + (properties.business_nyb || 0) + (properties.houses_nyb || 0))}
                <hr />
                Postcodes Included: {formatNumber(properties.total_postcodes || 0)} <br/>
                Streets Included: {formatNumber(properties.total_streets || 0)} <br/>
                Area: {formatNumber(measurementUnits === 'km' ? properties.area_km2 : properties.area_mi2) || 0} {measurementUnits === 'km' ? 'km' : 'mi'}<sup>2</sup>
            </div>
            </>) : null}

            {(data.type === ShapeStyling.TYPE_BUFFER) ? (<>
                <MarksInfoPanelBufferRadius
                    properties={data.geoJSON.properties}
                    onChange={(value) => {
                        if (bufferRadiusChanged) {
                            bufferRadiusChanged(value);
                        }
                    }}
                    canEdit={canEdit}
                />
            </>) : null}

            {(data.type === ShapeStyling.TYPE_POINT && data.geoJSON) ? (<>
                <hr/>
                <div className="">Location: {data.geoJSON.geometry.coordinates.join(', ')}</div>
            </>) : null}

            <hr/>

            {notesEditMode ? (<>
                <ShapePopup initialJSON={notes} onSave={(json) => {updateNotes(json);}} />
                <button className={'btn btn-sm btn-dark mt-3 '+(notesEditMode ? '' : 'd-none')} onClick={saveNotes}>Save changes</button>
            </>) : (<>
                <ShapeNotesDisplay initialJSON={notes} />
            </>)}
        </OnMapInfoPanel>
        <OnMapInfoPanel className={'style-warning'}>
            <MarksToolbar
                id={id}
                data={data}
                onEditNotes={setNotesEditMode}
                onMinimizePanel={onMinimizePanel}
                canEdit={canEdit}

                onInitRefresh={onInitRefresh}
                onSaveToFiles={onSaveToFiles}

                onLayerToTop={onLayerToTop}
                onLayerToBottom={onLayerToBottom}
                onToggleVisible={onToggleVisible}
                onTogglePopupTitle={onTogglePopupTitle}
                onConvertShape={onConvertShape}

                onColorChange={setCustomColor}
                onRemove={selfDelete}
            />
        </OnMapInfoPanel>
    </div>
    );
}